import React, { useMemo } from 'react';

const EmbedVk = ({link, iframeRef}) => {
    const emdedLink = useMemo(() => {
        if (link.includes('video_ext.php')) {
            return link;
        }

        if (!link.includes('video')) {
            return null;
        }
        const matches = link.match(/(-?[\d]*_[\d]*)/g)[0].split('_');
        
        return matches.length ? `https://vk.com/video_ext.php?oid=${matches[0]}&id=${matches[1]}` : null;
    }, [link]);

    if (!emdedLink) {
        return (<></>)
    }

    return (
        <iframe
            ref={iframeRef}
            src={emdedLink}
            width="900"
            height="532"
            frameBorder="0"
            allowFullScreen="1"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        />
    )
};

export default EmbedVk;
